import React from 'react'
import { orderBy, uniq } from 'lodash'
import { computed, makeAutoObservable, observable } from 'mobx'

import { fontSizeValidator } from 'common/Prose/Toolbar/components/Format/components/utils/changeFontSize'

import { FONT_SIZES } from '../constants'

export class FontSizeStore {
  fontSizes: number[] = [...FONT_SIZES]
  fontSize: number = FONT_SIZES[0]
  selectedPosition?: number
  fontSizeInput: number = FONT_SIZES[0]
  constructor() {
    makeAutoObservable(this, {
      fontSizes: observable,
      currentFont: computed,
    })
  }
  get currentFont(): number | undefined {
    if (this.selectedPosition != null) {
      return this.fontSizes[this.selectedPosition]
    }
    if (fontSizeValidator(this.fontSizeInput)) {
      return this.fontSizeInput
    }
    return undefined
  }
  setFontSizeInput(fontInput: typeof this.fontSizeInput) {
    this.selectedPosition = undefined
    if (fontInput === 0 || isNaN(fontInput)) {
      this.fontSizeInput = FONT_SIZES[0]
    } else {
      this.fontSizeInput = fontInput
    }
  }
  includeFontSizes(fonts: typeof this.fontSizes) {
    this.selectedPosition = 0
    this.fontSizes = orderBy(uniq([...FONT_SIZES, ...fonts]))
  }
  nextFont() {
    if (this.selectedPosition == null || this.selectedPosition + 1 > this.fontSizes.length) {
      this.selectedPosition = 0
    } else {
      this.selectedPosition++
    }
  }
  previousFont() {
    if (this.selectedPosition == null || this.selectedPosition - 1 < 0) {
      this.selectedPosition = undefined
    } else {
      this.selectedPosition--
    }
  }
}

export const FontSizeContext = React.createContext(new FontSizeStore())
